import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { PersistGate } from 'redux-persist/integration/react'
import { hot } from 'react-hot-loader'
import animateScrollTo from 'animated-scroll-to'
import { ConnectedRouter } from 'connected-react-router'
import { history } from '../config/Redux'
import BaseRoutes from './routing/BaseRoutes'
import ToastrWrapper from './shared/ToastrWrapper';
import ConnectedLoadingWrapper from './auth/LoadingWrapper';
import {Auth, Hub } from 'aws-amplify';
import {setSession} from '../lib/Utils';

history.listen((/* location */) => {
  //This method scrolls the page to the top when a route is changed.
  //Otherwise in a SPA the page might by default stay scrolled to its current position.
  animateScrollTo(0, {
    speed: 500,
    minDuration: 0,
    maxDuration: 250,
    element: window,
    offset: 0,
    cancelOnUserAction: true,
    passive: true,
  })
})

class App extends PureComponent {
  componentDidMount() {
    Hub.listen('auth', ({ payload: { event, data } }) => {
      switch (event) {
        case 'signIn': {
          this.setState({user: data});
          setSession();
          break;
        }
        case 'signOut':
          this.setState({ user: null });
          break;
        case 'customOAuthState':
          this.setState({ customState: data });
      }
    });

    Auth.currentSession()
      .then(user => this.setState({ user }))
      .catch(() => console.error('Not signed in'));
  }
  render() {
    return (
      <PersistGate loading={null} persistor={this.props.persistor}>
        <ConnectedRouter history={history}>
          <ConnectedLoadingWrapper/>
          <BaseRoutes />
        </ConnectedRouter>
        <ToastrWrapper/>
      </PersistGate>
    )
  }
}

App.propTypes = {
  persistor: PropTypes.object,
};

App.defaultProps = {
  myAction: null,
};

export default hot(module)(App)
